(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('SupplierDetailController', SupplierDetailController);
//    SupplierDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils','Supplier'];
//
//    function SupplierDetailController($scope, $rootScope, $stateParams, DataUtils, Supplier) {
//    	var vm = this;
//        vm.supplier1 = [{code:'AD',name:'Á Đông', typeService:'In giấy giới thiệu trích sao HS bệnh án',userContact:'Anh Trung',phone:'3551 0831',status:'1'},
//                       {code:'BD',name:'In tem Bưu Điện', typeService:'Bao thư cửa sổ phải, bao thư 11x17, giấy tiêu đề tờ 1',userContact:'Anh Đình Hải',phone:'3551 0831',status:'1'},
//                       {code:'BNP',name:'Công ty cổ phần đầu tư DVN', typeService:'Giấy tiêu đề liên tục 2 liên, 3 liên',userContact:'Anh Đình Hải',phone:'3551 0831',status:'1'},
//                       {code:'DVN',name:'Cty Cổ Phần In Tổng Hợp Cần Thơ', typeService:'Sách',userContact:'Anh Trang',phone:'3551 0831',status:'1'},
//                       {code:'FA',name:'In Trần Phú', typeService:'GCN, ĐKHĐ, Bìa Regular & bìa VIP',userContact:'thuylinh@vaikhongdet.vn (094 982 7071 - 0917 548 045)',phone:'3551 0831',status:'1'}];
//        vm.supplier = vm.supplier1[0];
    SupplierDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'DataUtils', 'entity', 'Supplier'];

    function SupplierDetailController($scope, $rootScope, $stateParams, DataUtils, entity, Supplier) {
        var vm = this;

        vm.supplier = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        if(vm.supplier.status == 1){
        	vm.supplier.statusName = 'Đang hoạt động'
        }else{
        	vm.supplier.statusName = 'Ngừng hoạt động'
        }
        var unsubscribe = $rootScope.$on('setupApp:ClaimHospitalUpdate', function(event, result) {
            vm.supplier = result;
            
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
